'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bottle = require('./Bottle');

var _Bottle2 = _interopRequireDefault(_Bottle);

var _Locker = require('./Locker');

var _Locker2 = _interopRequireDefault(_Locker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Private Members
var tokenKey = Symbol('The token key');
var userKey = Symbol('The user key');
var locker = Symbol('The locker instance');

var extractToken = Symbol('This private method will be used to extract the token');
var extractUser = Symbol('This private method will be used to extract the user');

var Authentication = function () {
  function Authentication() {
    _classCallCheck(this, Authentication);

    this[tokenKey] = 'auth_token';
    this[userKey] = 'auth_user';
    this[locker] = new _Locker2.default();
  }

  _createClass(Authentication, [{
    key: extractToken,
    value: function value(data) {
      var access_token = data.access_token,
          token_type = data.token_type,
          expires_in = data.expires_in;


      return {
        access_token: access_token,
        token_type: token_type,
        expires_in: expires_in
      };
    }
  }, {
    key: extractUser,
    value: function value(data) {
      var userName = data.userName,
          personId = data.personId,
          firstName = data.firstName,
          lastName = data.lastName,
          fullName = data.fullName,
          email = data.email,
          phone = data.phone,
          companyName = data.companyName,
          customerId = data.customerId,
          customerOrgId = data.customerOrgId,
          userType = data.userType;

      // token api call based on MyCitrixHash doesn't return this property

      if (userType === undefined) {
        userType = 'External';
      }

      return {
        userName: userName,
        personId: personId,
        firstName: firstName,
        lastName: lastName,
        fullName: fullName,
        email: email,
        phone: phone,
        companyName: companyName,
        customerId: customerId,
        customerOrgId: customerOrgId,
        userType: userType
      };
    }
  }, {
    key: 'authenticate',
    value: function authenticate(authServiceURL) {
      var _this = this;

      var login = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var authCookie = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var bottle = new _Bottle2.default();
      var body = login.length === 0 ? 'Grant_Type=password' : 'Grant_Type=password&loginId=' + login;
      var axiosConfig = {
        headers: { contentType: 'application/x-www-form-urlencoded' },
        withCredentials: true // We need cookie only for token call
      };
      if (authCookie.length > 0) {
        document.cookie = authCookie;
      }
      return bottle.post(authServiceURL, body, axiosConfig).then(function (response) {
        _this.storeAuthenticationResponse(response);
      }).catch(function (e) {
        throw e;
      });
    }
  }, {
    key: 'storeAuthenticationResponse',
    value: function storeAuthenticationResponse(res) {
      if (res && res.data) {
        var token = this[extractToken](res.data);
        var user = this[extractUser](res.data);
        this[locker].setItem(this[tokenKey], token);
        this[locker].setItem(this[userKey], user);
      }
    }
  }, {
    key: 'getAuthenticationToken',
    value: function getAuthenticationToken() {
      return this[locker].getItem(this[tokenKey]);
    }
  }, {
    key: 'getAuthenticatedUser',
    value: function getAuthenticatedUser() {
      return this[locker].getItem(this[userKey]);
    }
  }]);

  return Authentication;
}();

exports.default = Authentication;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ctxs-vue-plugins/dist/classes/Authentication.js
// module id = LrMP
// module chunks = 0